import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const EditFaqModal = ({ show, handleClose, data, handleSave }) => {
  const [form, setForm] = useState(data);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Faq</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Question</Form.Label>
            <Form.Control
              value={form.question}
              onChange={(e) =>
                setForm({ ...form, question: e.target.value })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Answer</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={form.answer}
              onChange={(e) =>
                setForm({ ...form, answer: e.target.value })
              }
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Category</Form.Label>
            <Form.Control
              value={form.category}
              onChange={(e) =>
                setForm({ ...form, category: e.target.value })
              }
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className="bg-transparent text-dark border border-1" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          style={{ background: "#f97316", border: "none" }}
          onClick={() => handleSave(form)}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditFaqModal;